export default __webpack_public_path__ + "static/media/093-diagonal-arrow-7.91d89025.png";